var _desc, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAirlines = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Plane-Trip-1--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Plane Trip 1 Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.11 5.14A3 3 0 1 0 18.86 0.89l-2.74 2.74a0.53 0.53 0 0 1 -0.36 0.15l-4.11 0C5 3.71 1.94 3.7 0.67 5A2.47 2.47 0 0 0 0 6.81c0 2.34 2.1 2.43 5.28 2.55 1.07 0.05 2.31 0.1 3.72 0.23a0.51 0.51 0 0 1 0.43 0.33 0.5 0.5 0 0 1 -0.12 0.52L5 14.76a0.51 0.51 0 0 1 -0.35 0.15H2.52A2.52 2.52 0 0 0 0 17.43c0 1.89 1.39 2.28 2.86 2.69l0.52 0.16a0.47 0.47 0 0 1 0.34 0.33c0 0.17 0.1 0.33 0.14 0.49 0.4 1.42 0.82 2.9 2.71 2.9a2.52 2.52 0 0 0 2.52 -2.52v-2.12a0.51 0.51 0 0 1 0.15 -0.36l4.32 -4.32a0.5 0.5 0 0 1 0.52 -0.12 0.51 0.51 0 0 1 0.33 0.43c0.13 1.41 0.18 2.66 0.22 3.73 0.13 3.17 0.22 5.27 2.56 5.27a2.76 2.76 0 0 0 2.08 -0.71c1.14 -1.16 1.1 -3.67 1 -9.17 0 -1.67 -0.06 -3.62 -0.06 -5.89a0.47 0.47 0 0 1 0.15 -0.35Z",
    fill: "currentColor",
    strokeWidth: 1
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAirlines);
export default ForwardRef;